module.exports = __webpack_public_path__ + "img/current.a31d9cf1.svg";